const storeNameMap = {
    'Склад "Ткачёва"': 'Магазин Ткачёва 11',
    'Красноармейский': 'Магазин Героев Сталинграда 46',
    'Нефтяников 2к1': 'Центральный склад',
    'Склад "Кузнецова ОФИС"': 'Магазин Кузнецова 20',
    'Птичий рынок': 'Магазин Вершинина 1',
    'Склад поставщика': 'Удалённый склад (1-3 дня поставка)',
    'Склад поставщика Р': 'Удалённый склад (3-8 дня поставка)',


    // добавляй сюда сколько угодно
};

export function getDisplayStoreName(originalName) {
    return storeNameMap[originalName] || originalName;
}
